@import 'styles/mixins';
@import 'styles/variables';
@import 'styles/blaze/mixins';

.row {
  position: relative;
  display: grid;
  grid-template-columns: 50px 80px 1fr 140px 160px;
  align-items: center;
  min-height: 60px;
  padding: 9px 0;
  border-bottom: 1px solid var(--dark-4);
  background-color: var(--light-80);
  transition: background-color 150ms ease, box-shadow 150ms ease, border-color 150ms ease;
  cursor: pointer;

  &.hideSelectionColumn {
    grid-template-columns: 100px 1fr 140px 160px;
  }

  &:hover {
    background-color: var(--light-80);
    @include container-shadow;

    .favoriteButton {
      opacity: 1;
      pointer-events: auto;
    }
  }

  &.selected {
    background: var(--selected-fill-10);
    border-bottom: 1px solid transparent;

    .favoriteButton {
      opacity: 1;
      pointer-events: auto;
    }
  }

  @include for-phone-only {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    gap: 12px;
    min-height: 56px;
  }
}

.cell {
  display: flex;
  align-items: center;
  height: 100%;
  padding-left: 20px;

  @include for-phone-only {
    padding-left: 0;
    height: auto;
  }
}

.previewCell {
  padding-left: 5px;
  padding-right: 0;

  @include for-phone-only {
    display: none;
  }
}

.preview {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
  display: block;
  background-color: var(--light-80);
  object-position: top;
  box-shadow: 0 1px 5px #0000001a, 0.5px 0.5px #fff3 inset;
}

.previewPlaceholder {
  width: 80px;
  height: 80px;
  border-radius: 5px;
  background-color: var(--light-80);
  display: block;
}

.textPreviewContainer {
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  overflow: hidden;
  padding: 8px 8px 0 8px;
  border-radius: 5px;
  background-color: var(--light-100);
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.1), 0.5px 0.5px 0px 0px rgba(255, 255, 255, 0.2) inset;
  display: flex;
  flex-direction: column;
}

.textPreviewTitle {
  color: var(--dark-100);
  background-color: var(--light-100);
  font-size: 10px;
  font-weight: 500;
  text-align: start;
  line-height: 12px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.textPreview {
  @include line-clamp(9);
  color: var(--dark-80);
  align-items: flex-start;
  font-size: 4px;
  font-weight: 400;
  text-align: start;
  line-height: 5px;
  text-wrap: initial;
  flex: 1;
}

.indexCell {
  justify-content: center;
  align-items: center;
  color: var(--dark-40);
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  font-variant-numeric: tabular-nums;
  padding-left: 0;
  padding-right: 0;

  @include for-phone-only {
    padding-left: 0;
  }
}

.checkboxCell {
  padding-left: 20px;
  padding-right: 0;
}

.titleCell {
  display: flex;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  gap: 4px;
  min-width: 0;

  @include for-phone-only {
    flex: 1 1 auto;
    gap: 10px;
  }
}

.iconWrapper,
.channelIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background-color: $gray-10;
  color: var(--dark-80);
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
  }
}

.channelIcon {
  background-color: transparent;
  width: auto;
  height: auto;

  svg {
    width: 20px;
    height: 20px;
  }
}

.emojiIcon {
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
}

.titleContent {
  display: inline-flex;
  align-items: center;
  gap: 15px;
  flex: 1 1 auto;
  min-width: 0;
  max-width: 100%;
  position: relative;

  @include for-phone-only {
    flex: 1 1 auto;
    gap: 10px;
  }
}

.titleContentRenaming {
  flex: 1 1 auto;
  width: 100%;
}

.titleButton {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  width: auto;
  max-width: 100%;
  flex: 1 1 auto;
  min-width: 0;
  text-align: left;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.titleContentWrapper {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 auto;
  min-width: 0;

  @include for-phone-only {
    gap: 10px;
  }
}

.titleText {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.favoriteButton {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.favoriteToggle {
  width: 24px;
  height: 24px;
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms ease;

  svg {
    width: 18px;
    height: 18px;
  }

  @include for-phone-only {
    display: none;
  }
}

.favoriteToggle.favoriteButtonActive {
  svg {
    fill: $gold-50;
  }
}

.row:hover .favoriteToggle,
.row.selected .favoriteToggle {
  opacity: 1;
  pointer-events: auto;
}

.renameForm {
  width: 100%;
}

.postAtCell,
.statusCell {
  @include for-phone-only {
    display: none;
  }
}

.mobileActions {
  justify-content: flex-end;
  padding-left: 0;

  @include for-phone-only {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-left: 12px;
  }
}

.mobileStatus {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  @include for-phone-only {
    .statusTag {
      > [data-tag] {
        font-size: 12px;
        padding: 2px 8px;
      }
    }
  }
}

.renameInput {
  width: 100%;
  border: 1px solid var(--dark-10);
  border-radius: 6px;
  padding: 6px 10px;
  font-size: 16px;
  line-height: 1.3;
  font-family: inherit;
  color: var(--dark-80);
  background: var(--light-80);

  &:focus {
    outline: none;
    border-color: var(--action-50);
    box-shadow: 0 0 0 3px rgba(40, 127, 189, 0.2);
  }
}

.postAtCell {
  justify-content: flex-start;
  color: var(--dark-60);
  white-space: nowrap;
  padding-left: 20px;

  @include for-phone-only {
    font-size: 12px;
    padding-left: 0;
  }
}

.statusCell {
  justify-content: flex-start;
  min-width: 0;
  padding-left: 20px;

  @include for-phone-only {
    padding-left: 0;
  }
}

.statusPlaceholder {
  color: var(--dark-40);
}

.statusTag {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  gap: 6px;

  [data-autopilot-system-redesign='on'] & {
    border: 1px solid var(--dark-4);
    border-radius: 999px;
    align-self: center;
    gap: 0;
    height: 26px;
  }

  &:empty {
    display: none;
  }

  > [data-tag] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
}

.hybridAlertIcon {
  background-color: var(--negative-20);
  border-radius: 16px;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.connectTagText {
  display: flex;
  align-items: center;
  gap: 4px;
}

.connectTagButton {
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  display: inline-flex;
}

.connectTagButton:focus-visible {
  outline: 2px solid var(--action-50);
  outline-offset: 2px;
  border-radius: 999px;
}

.rowNumber {
  color: var(--neutral-40);
  font-size: 13px;
  letter-spacing: 0.2px;
}
